import { Box } from '@factorialco/deprecated-design-system'
import { WorkScheduleScheduleFragment } from 'generated/resources/graphql'

import { Controls, InfiniteLoader } from 'modules/core/hooks/usePaginatedQuery'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'

import WorkScheduleTable from './WorkScheduleTable'

interface Props {
  schedules: WorkScheduleScheduleFragment[]
  controls: Controls
  archived?: boolean
  contractVersions: ContractVersions
}

const PaginatedSchedulesList = ({ schedules, controls, archived, contractVersions }: Props) => {
  return (
    <Box
      data-scroll-container
      width="full"
      overflowY="auto"
      style={{ maxHeight: 'calc(100vh - 215px)' }}
    >
      <InfiniteLoader controls={controls}>
        <Box gap="s16">
          {schedules.map((schedule) => (
            <Box key={schedule.id}>
              <WorkScheduleTable
                schedule={schedule}
                archived={archived}
                contractVersions={contractVersions}
              />
            </Box>
          ))}
        </Box>
      </InfiniteLoader>
    </Box>
  )
}

export default PaginatedSchedulesList
